module.exports = __webpack_public_path__ + "static/img/fclab-pipette2.ca5fe4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/fclab-pipette2.jpg
// module id = i7Qo
// module chunks = 0